import { render, staticRenderFns } from "./AppWrap.vue?vue&type=template&id=0c6899fc&"
import script from "./AppWrap.vue?vue&type=script&lang=js&"
export * from "./AppWrap.vue?vue&type=script&lang=js&"
import style0 from "./AppWrap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports